export default __webpack_public_path__ + "static/media/home_pic5.0e6681f3.png";